// extracted by mini-css-extract-plugin
module.exports = {"preview":"_2JMHaN","spinner":"_1zCV8G"};